/**
 * @ngdoc directive
 * @name WebCoreModule.directive:ngPrism
 * @restrict A
 * @description
 * The ngPrism directive adds behavior to highlight element.
 */
angular.module('WebCoreModule')
    .directive('prism', [function() {
        return {
            restrict: 'A',
            link: function ($scope, element) {
                element.ready(function() {
                    Prism.highlightElement(element[0]);
                });
            }
        };
    }]
);